<template>
  <!-- mediaBox add -->
  <div >
    <a-modal
      title="查看附件"
      :visible="visible"
      :footer=null
      @cancel="closeFun"
      :maskClosable=true
      :keyboard=false
      :destroyOnClose=true
      :centered=true

      width='540px'
    >
      <div>
        <template v-for="(el, index) of list" >
          <img :key='index' :src = 'el' class="img" @click="btn_img(el)"/>
        </template>
      </div>
    </a-modal>

    <a-modal
      title="查看"
      :visible="showimg"
      :footer=null
      @cancel="closebigimgFun"
      :maskClosable=true
      :keyboard=false
      :destroyOnClose=true
      :centered=true
      width="auto"
    >
      <div style="text-align:center">
        <img :src="src" class="bigimg" v-show = '!longimg'/>
        <img :src="src" class="longimg"  v-show = 'longimg'/>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'mediaBox',
  components: { },
  data () {
    return {
      visible: false,
      list: [],
      clientTop: 0,
      showimg: false,
      src: undefined,
      longimg: false
    };
  },
  created () {
  },
  methods: {
    btn_img (src) {
      this.src = src;
      this.longimg = false;
      this.showimg = true;
      setTimeout(() => {
        let wh = document.getElementsByClassName('bigimg')[0].height / document.getElementsByClassName('bigimg')[0].width;
        if (wh > 2.2) {
          this.longimg = true;
        }
      }, 100);
    },
    closebigimgFun () {
      this.showimg = false;
    },
    closeFun () {
      this.visible = false;
      setTimeout(() => {
        window.scrollTo({
          top: this.clientTop
        });
      }, 10);
    },
    show (list, top) {
      this.clientTop = 0;
      this.clientTop = top;
      this.list = [];
      this.list = list;
      this.visible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.img{
  width: 100px;
  height: 100px;
  margin:10px;
  background: #e7e5e5;
  border: 0 !important;
  object-fit:cover;
  }
.bigimg{
  max-height: 600px;
  max-width: 1000px;
  display: inline-block;
  margin: 0 auto;
}
.longimg{
  max-width: 1000px;
  display: inline-block;
  margin: 0 auto;
}
</style>
